import React, { Component } from 'react';
import styled from 'styled-components';
import { ATM_CONSTANTS, pushPageViewEvent } from '@lib/atm';
import CanadaFlag from '../../../svgs/CanadaFlag';
import UsaFlag from '../../../svgs/UsaFlag';
import {
  CAD,
  USD,
  DOM_OFFER_MODAL,
  DATA_TRACK_TYPE_CTA,
} from '../../../../lib/constants';
import {
  trackAnalytics,
  toSlug,
  attachLocale,
  attachShopSlug,
  resolveAccessibleLabel,
} from '../../../../lib/utils';
import Button from '../Button/Button';
import CheckIcon from '../../../svgs/CheckIcon';
import MilesOffer from '../shared/MilesOffer';
import PromoBadge from '../PromoBadge/PromoBadge';
import DateDisplay from '../DateDisplay/DateDisplay';
import EndDatesGroup from '../shared/EndDatesGroup';
import { withAnalyticsPageName } from '../Pages/AnalyticsPageContext';
import ShopNowButton from '../Button/ShopNowButton';

const SectionTitleDiv = styled.div`
  ${({ theme }) => theme.typographyRebrand.body.md}
  font-weight: var(--typography-font-weight-bold);
  color: ${p => p.theme.c.text.primary};
`;

const DisclaimerText = styled.div`
  ${({ theme }) => theme.typographyRebrand.body.md}
  color: ${p => p.theme.c.text.primary};
`;

const TermsAndConditionsdiv = styled.div`
  max-height: ${p => p.theme.unit(69)};
  overflow: scroll;

  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.unit(1)};
`;

const OfferModalDiv = styled.div`
  background-color: ${p => p.theme.c.bg.primary};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.unit(3)};
  padding: ${({ theme }) => `${theme.unit(6)} ${theme.unit(7)}`};
  max-width: ${({ theme }) => theme.unit(110)};

  @media screen and (min-width: ${(p) => p.theme.minWidthBreakpoint.desktop}px) {
    flex-direction: row;
  }

  ${({ theme }) => theme['elevation-shadow']['3']}
`;

const ShopLogoImg = styled.img`
  max-width: ${p => p.theme.unit(14)};
  max-height: ${p => p.theme.unit(6)};
`;

const FlagDiv = styled.div`
  max-width: ${p => p.theme.unit(4)};
  max-height: ${p => p.theme.unit(2)};
  padding-right: ${p => p.theme.unit(1)};
`;

const CurrencyDiv = styled.div`
  ${({ theme }) => theme.typographyRebrand.body.md}
  color: ${p => p.theme.c.text.primary};
  display: flex;
  flex-direction: row;
`;

const OfferTypeBadge = styled.span`
  ${({ theme }) => theme.typographyRebrand.body.sm}
  color: ${p => p.theme.c.text.primary};
  background-color: ${p => p.theme.c.bg['feature-4']};
  padding: ${p => p.theme.unit(0.25)} ${p => p.theme.unit(2)};

  display: inline-block;
  border-radius: ${({ theme }) => theme.radius.lg};

  margin-right: ${p => p.theme.unit(0.5)};
`;

const ColumnOne = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${({ theme }) => theme.unit(3)};
  flex-grow: 1;
`;

const ColumnTwo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: center;
  width: ${({ theme }) => theme.unit(32)};
  max-width: ${({ theme }) => theme.unit(52)};
  
  gap: ${({ theme }) => theme.unit(3)};
`;

const OfferDescription = styled.div`
  ${({ theme }) => theme.typographyRebrand.body.md};
  color: ${p => p.theme.c.text.primary};
`;

const OfferImageContainerDiv = styled.div`
  border: 1px solid ${p => p.theme.c.border.primary};
  padding: ${p => p.theme.unit(1)};
  max-width: ${p => p.theme.unit(32)};
  max-height: ${p => p.theme.unit(32)};
`;

const OfferImg = styled.img`
  max-width: inherit;
  max-height: inherit;
`;

const OfferCodeSpan = styled.span`
  ${({ theme }) => theme.typographyRebrand.body.sm}
  color: ${p => p.theme.c.tag.text.primary};
  background-color: ${p => p.theme.c.tag.bg.secondary};
  padding: ${p => p.theme.unit(0.25)} ${p => p.theme.unit(2)};
  display: inline-block;
  align-self: flex-start;
  width: fit-content;
`;

const CouponCodeContainer = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${({ theme }) => theme.unit(1)};
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  width: 100%;

  gap: ${({ theme }) => theme.unit(2)};
`;

const PAGE_CONTEXT = 'offer-modal';
const emptyCallback = () => {};

class OfferModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFavourite: false,
      isSaveHovering: false,
    };

    this.favouriteButton;
  }

  componentWillMount() {
    const isFavourite = !!this.props.isFavourite;
    this.setState({
      isFavourite,
    });
  }

  componentDidMount() {
    const {
      userData,
      analyticsPageName,
      locale,
      slug,
    } = this.props;

    if (!analyticsPageName) {
      return;
    }

    pushPageViewEvent(
      window,
      userData,
      {
        locale,
        sections: [
          analyticsPageName,
          'shops_pop-up',
          slug.replaceAll('-', '_')
        ],
        pageCategory: ATM_CONSTANTS.categories.popUp,
      }
    );
  }

  componentDidUpdate() {
    // After updating, set focus to favourite button if applicable
    this.props.pageStateModifiers &&
      this.props.pageStateModifiers.setElementFocus &&
      this.props.pageStateModifiers.setElementFocus(PAGE_CONTEXT, this.props.id, this.favouriteButton);
  }

  render() {
    const {
      isMobile,
      id,
      slug,
      affiliateUrl,
      recencyOfOffersDays,
      imageAltText,
      exclusionsApply,
      viewType,
      shortDescription,
      couponCode,
      shortHeader,
      isFavourite,
      offerTypes,
      removeItemHandler = emptyCallback,
      saveItemHandler = emptyCallback,
      shop,
      shop: {
        multiplier,
        siteWideMultiplier,
      },
      locale,
      tags,
      dataLayerId,
      dataContextContainer,
      offerStartDate,
      offerEndDate,
      imageUrl,
      primaryLink,
      singularMilesText,
      pluralMilesText,
      singularFlatRateMilesText,
      pluralFlatRateMilesText,
      exclusionsApplyText,
      milesBadgeText,
      codeText,
      endsText,
      couponDisclaimerText,
      baseMiles,
      amountPerBaseMiles,
      mediumImageAltText,
      mediumImageUrl,
      currency = CAD,
      termsAndConditions,
      modalButtonOneText = 'Store Info',
      modalButtonOneTagSet,
      modalButtonTwoText = 'Save Offer',
      modalButtonTwoTextSaved = 'Saved',
      modalButtonThreeText = 'Shop Now',
      modalButtonThreeTagSet,
      modalCouponCodeTitle,
      modalTermsAndConditionsTitle,
      pageStateModifiers = {},
      descriptiveText,
      prepositionKey,
      linkTextPrepositions,
      favouriteAddLabel,
      favouriteRemoveLabel,
    } = this.props;

    const {
      syncUserDataOnPage = emptyCallback,
      isUserLoggedIn = emptyCallback,
      makeAndOpenSignInModal = emptyCallback,
      setActiveFocus = emptyCallback,
    } = pageStateModifiers;

    const shopSlug = shop && shop.slug ? shop.slug : '';

    const FlagToUse = (currency === USD) ? UsaFlag : CanadaFlag;
    const modalTrackingLocation = `page:shops-pop-up:${slug}`;

    const storeInfoLink = attachLocale(attachShopSlug(shopSlug), locale);
    const storeInfoText = modalButtonOneText;
    const storeInfoTrack = trackAnalytics(DOM_OFFER_MODAL, toSlug(storeInfoText), storeInfoLink, modalButtonOneTagSet);

    const saveOfferText = modalButtonTwoText;

    const savedOfferText = modalButtonTwoTextSaved;

    const shopNowText = modalButtonThreeText;
    const trackShopNowAnalytics = (redirectUrl) => ({
      ...trackAnalytics(DOM_OFFER_MODAL, toSlug(shopNowText), redirectUrl, modalButtonThreeTagSet),
      dataTrackingId: 'shop-now',
      dataTrack: modalTrackingLocation,
    });

    const shopNowLabel = resolveAccessibleLabel(
      descriptiveText,
      shop,
      linkTextPrepositions,
      'at1',
      shopNowText,
      shortHeader !== null ? shortHeader : shortDescription,
      prepositionKey !== null ? prepositionKey : 'and',
    );

    const storeInfoLabel = resolveAccessibleLabel(
      null,
      shop,
      linkTextPrepositions,
      'for',
      storeInfoText,
    );

    const removeOfferHandler = () => {
      if (isUserLoggedIn()) {
        removeItemHandler(id, () => {
          setActiveFocus(PAGE_CONTEXT, id);
          syncUserDataOnPage();
          this.setState({
            isFavourite: false,
          });
        });
      } else {
        makeAndOpenSignInModal();
      }
    };

    const saveOfferHandler = () => {
      if (isUserLoggedIn()) {
        saveItemHandler(id, this.props.endDate, () => {
          setActiveFocus(PAGE_CONTEXT, id);
          syncUserDataOnPage();
          this.setState({
            isFavourite: true,
          });
        });
      } else {
        makeAndOpenSignInModal();
      }
    };

    const {
      isFavourite: stateIsFavourite,
      isSaveHovering,
    } = this.state;

    const statelessSaveOfferButtonProps = {
      variant: 'secondary',
      size: 'medium',
      fullWidth: true,
      buttonText: stateIsFavourite ? savedOfferText : saveOfferText,
      'aria-label': stateIsFavourite ? favouriteRemoveLabel : favouriteAddLabel,
      title: stateIsFavourite ? favouriteRemoveLabel : favouriteAddLabel,
      dataTrackingId: stateIsFavourite ? 'unsave' : 'save',
      dataTrack: modalTrackingLocation,
      dataTrackType: DATA_TRACK_TYPE_CTA,
      dataLayerId,
      dataContextContainer,
    };

    return (
      <OfferModalDiv aria-modal="true">
        <ColumnOne>
          {mediumImageUrl && (
            <div>
              <ShopLogoImg src={mediumImageUrl} alt={mediumImageAltText} />
            </div>
          )}

          <div>
            {multiplier && (
              <PromoBadge
                extraMilesText={shop.config.extraMilesText}
                pluralFlatRateMilesText={pluralFlatRateMilesText}
              />
            )}
            <MilesOffer
              size="xl"
              singularMilesText={singularMilesText}
              pluralMilesText={pluralMilesText}
              baseMiles={baseMiles}
              multiplier={multiplier}
              siteWideMultiplier={siteWideMultiplier}
              singularFlatRateMilesText={singularFlatRateMilesText}
              pluralFlatRateMilesText={pluralFlatRateMilesText}
              milesBadgeText={milesBadgeText}
              amountPerBaseMiles={amountPerBaseMiles}
            />
          </div>

          {/* Currency Flag */}
          <CurrencyDiv>
            <FlagDiv>
              <FlagToUse />
            </FlagDiv>
            {currency}
          </CurrencyDiv>

          {/* Short description */}
          <OfferDescription>
            {shortDescription}
          </OfferDescription>

          {/* Offer Types */}
          {offerTypes && offerTypes.length >= 1 && offerTypes.some((ot) => Boolean(ot.visibleInOffer)) && (
            <div>
              {offerTypes.map((ot, index) => {
                return (ot.visibleInOffer
                  ? <OfferTypeBadge key={`${ot.name}-${index}`}>{ot.name}</OfferTypeBadge>
                  : null);
              })}
            </div>
          )}

          {/* Offer End Date Group */}
          {(multiplier || siteWideMultiplier || offerEndDate) && (
            <EndDatesGroup>
              <DateDisplay
                preText={endsText}
                dates={[
                  multiplier && multiplier.endDate,
                  siteWideMultiplier && siteWideMultiplier.endDate,
                  offerEndDate,
                ]}
                className="medium"
                locale={locale}
              />
            </EndDatesGroup>
          )}

          {/* Coupon code buttons */}
          {couponCode && (
            <CouponCodeContainer>
              <SectionTitleDiv>{modalCouponCodeTitle}</SectionTitleDiv>
              <DisclaimerText>{couponDisclaimerText}</DisclaimerText>
              <OfferCodeSpan>{codeText} {couponCode}</OfferCodeSpan>
            </CouponCodeContainer>
          )}

          {/* Terms and Conditions */}
          {termsAndConditions && (
            <TermsAndConditionsdiv>
              <SectionTitleDiv>{modalTermsAndConditionsTitle}</SectionTitleDiv>
              <div>{termsAndConditions}</div>
            </TermsAndConditionsdiv>
          )}
        </ColumnOne>

        <ColumnTwo>
          {/* Offer Image */}
          {imageUrl && (
            <OfferImageContainerDiv>
              <OfferImg src={imageUrl} alt={imageAltText} />
            </OfferImageContainerDiv>
          )}

          {/* Set of 3 anchor buttons */}
          <ButtonsContainer>
            <Button
              variant="secondary"
              size="medium"
              fullWidth
              accessibleLabel={storeInfoLabel}
              {...storeInfoTrack}
              dataTrackingId="store-info"
              dataTrack={modalTrackingLocation}
              dataTrackType={DATA_TRACK_TYPE_CTA}
              dataLayerId={dataLayerId}
              dataContextContainer={dataContextContainer}
              buttonText={storeInfoText}
            />

            <Button
              {...statelessSaveOfferButtonProps}
              renderLeftIcon={({ className }) => (
                <CheckIcon className={className} active={stateIsFavourite} hover={isSaveHovering} />
              )}
              innerRef={element => this.favouriteButton = element}
              onClick={stateIsFavourite ? () => removeOfferHandler(isMobile) : () => saveOfferHandler(isMobile)}
              onMouseEnter={() => { this.setState({ isSaveHovering: true }); }}
              onMouseLeave={() => { this.setState({ isSaveHovering: false }); }}
            />

            <ShopNowButton
              variant="primary"
              size="medium"
              fullWidth
              shopSlug={shopSlug}
              offerSlug={slug}
              locale={locale}
              trackAnalytics={trackShopNowAnalytics}
              accessibleLabel={shopNowLabel}
              dataLayerId={dataLayerId}
              dataContextContainer={dataContextContainer}
              buttonText={shopNowText}
            />
          </ButtonsContainer>
        </ColumnTwo>
      </OfferModalDiv>
    );
  }
}

export default withAnalyticsPageName(OfferModal);
